import { useQuery } from "@tanstack/react-query";
import { useState } from "react";

import { listDevices } from "@/api/endpoints/devices";

function formatDate(iso: string | null): string {
  return iso ? new Date(iso).toLocaleString() : "—";
}

export function DevicesPage() {
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);

  const query = useQuery({
    queryKey: ["devices", search, page],
    queryFn: () => listDevices(search, page),
  });

  const totalPages = query.data ? Math.max(1, Math.ceil(query.data.total / query.data.page_size)) : 1;

  return (
    <div className="flex flex-col gap-4">
      <input
        placeholder="Search MAC or username…"
        value={search}
        onChange={(e) => {
          setSearch(e.target.value);
          setPage(1);
        }}
        className="w-72 rounded-md border border-border bg-surface-2 px-3 py-2 text-sm text-text outline-none focus:border-accent"
      />

      <div className="overflow-x-auto rounded-lg border border-border bg-surface">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-border text-left text-xs uppercase tracking-wide text-text-muted">
              <th className="px-4 py-3">MAC address</th>
              <th className="px-4 py-3">Vendor</th>
              <th className="px-4 py-3">Seen with</th>
              <th className="px-4 py-3">First seen</th>
              <th className="px-4 py-3">Last seen</th>
              <th className="px-4 py-3">Sessions</th>
            </tr>
          </thead>
          <tbody>
            {query.data?.items.map((d) => (
              <tr key={d.callingstationid} className="border-b border-border last:border-0">
                <td className="px-4 py-3 font-mono text-text">{d.callingstationid}</td>
                <td className="px-4 py-3 text-text-muted">{d.vendor}</td>
                <td className="px-4 py-3 font-mono text-text-muted">{d.usernames.join(", ") || "—"}</td>
                <td className="px-4 py-3 text-text-muted">{formatDate(d.first_seen)}</td>
                <td className="px-4 py-3 text-text-muted">{formatDate(d.last_seen)}</td>
                <td className="px-4 py-3 tabular-nums text-text">{d.session_count}</td>
              </tr>
            ))}
            {query.data?.items.length === 0 && (
              <tr>
                <td colSpan={6} className="px-4 py-8 text-center text-text-muted">
                  No devices match.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {query.data && totalPages > 1 && (
        <div className="flex items-center gap-3 text-sm text-text-muted">
          <button disabled={page <= 1} onClick={() => setPage((p) => p - 1)} className="rounded border border-border px-2 py-1 disabled:opacity-40">
            Prev
          </button>
          <span>
            Page {page} of {totalPages} · {query.data.total} devices
          </span>
          <button disabled={page >= totalPages} onClick={() => setPage((p) => p + 1)} className="rounded border border-border px-2 py-1 disabled:opacity-40">
            Next
          </button>
        </div>
      )}
    </div>
  );
}
